module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('div', [_c('h2', [_vm._v("基础信息入库"), _c('el-steps', {
    attrs: {
      "space": 50,
      "active": _vm.step,
      "finish-status": "success",
      "simple": "simple"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "检验"
    }
  }), _c('el-step', {
    attrs: {
      "title": "入库"
    }
  }), _c('el-step', {
    attrs: {
      "title": "完成"
    }
  })], 1)], 1), (_vm.detail && _vm.step === 1) ? _c('div', {
    staticClass: "form-box",
    attrs: {
      "inline": true
    }
  }, [_c('el-form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "类别"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.CATEGORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "CATEGORYNAME", $$v)
      },
      expression: "detail.CATEGORYNAME"
    }
  })], 1), _c('el-form-item', [_c('p', {
    class: _vm.reviewStatus.new_category ? 'hilight' : ''
  }, [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_category)))])]), _c('el-form-item'), (!_vm.categoryConfirmed) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleComfirmed('category')
      }
    }
  }, [_vm._v("确认")]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleCancel('category')
      }
    }
  }, [_vm._v("取消确认")])], 1), _c('div', {
    staticClass: "group",
    class: _vm.categoryConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "size": "small",
      "value": "names",
      "fetch-suggestions": _vm.querySearchCategories,
      "placeholder": "查找现有类别",
      "trigger-on-focus": false,
      "debounce": 500
    },
    on: {
      "select": _vm.handleSelectCategory
    },
    model: {
      value: (_vm.categorySelectedText),
      callback: function($$v) {
        _vm.categorySelectedText = $$v
      },
      expression: "categorySelectedText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleReplace('category')
      }
    }
  }, [_vm._v("替换")])], 1)], 1), _c('div', {
    staticClass: "group",
    class: _vm.categoryConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "修改类别"
    },
    model: {
      value: (_vm.categoryModifyText),
      callback: function($$v) {
        _vm.categoryModifyText = $$v
      },
      expression: "categoryModifyText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleModify('category')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "厂商简称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.FACTORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "FACTORYNAME", $$v)
      },
      expression: "detail.FACTORYNAME"
    }
  })], 1), _c('el-form-item', [_c('p', {
    class: _vm.reviewStatus.new_company_alias ? 'hilight' : ''
  }, [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_company_alias)))])]), _c('el-form-item'), (!_vm.aliasConfirmed) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleComfirmed('company_alias')
      }
    }
  }, [_vm._v("确认")]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleCancel('company_alias')
      }
    }
  }, [_vm._v("取消确认")])], 1), _c('div', {
    staticClass: "group",
    class: _vm.aliasConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "size": "small",
      "value": "label",
      "value-key": "label",
      "fetch-suggestions": _vm.querySearchAlias,
      "placeholder": "查找现有公司简称",
      "trigger-on-focus": false,
      "debounce": 500
    },
    on: {
      "select": _vm.handleSelectAlias
    },
    model: {
      value: (_vm.aliasSelectedText),
      callback: function($$v) {
        _vm.aliasSelectedText = $$v
      },
      expression: "aliasSelectedText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleReplace('company_alias')
      }
    }
  }, [_vm._v("替换")])], 1)], 1), _c('div', {
    staticClass: "group",
    class: _vm.aliasConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "修改厂商简称"
    },
    model: {
      value: (_vm.aliasModifyText),
      callback: function($$v) {
        _vm.aliasModifyText = $$v
      },
      expression: "aliasModifyText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleModify('company_alias')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.PRODUCTNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "PRODUCTNAME", $$v)
      },
      expression: "detail.PRODUCTNAME"
    }
  })], 1), _c('el-form-item', [_c('p', {
    class: _vm.reviewStatus.new_product ? 'hilight' : ''
  }, [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_product)))])]), _c('el-form-item'), (!_vm.productConfirmed) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleComfirmed('product')
      }
    }
  }, [_vm._v("确认")]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleCancel('product')
      }
    }
  }, [_vm._v("取消确认")])], 1), _c('div', {
    staticClass: "group",
    class: _vm.productConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "size": "small",
      "value": "label",
      "value-key": "label",
      "fetch-suggestions": _vm.querySearchProduct,
      "placeholder": "查找现有产品",
      "debounce": 500
    },
    on: {
      "select": _vm.handleSelectProduct
    },
    model: {
      value: (_vm.productSelectedText),
      callback: function($$v) {
        _vm.productSelectedText = $$v
      },
      expression: "productSelectedText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleReplace('product')
      }
    }
  }, [_vm._v("替换")])], 1)], 1), _c('div', {
    staticClass: "group",
    class: _vm.productConfirmed ? 'hi' : ''
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "修改产品名称"
    },
    model: {
      value: (_vm.productModifyText),
      callback: function($$v) {
        _vm.productModifyText = $$v
      },
      expression: "productModifyText"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleModify('product')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)])]), _c('div', {
    staticClass: "el-form-item bottom-ctrl"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fillAndCheck
    }
  }, [_vm._v("检验")]), _c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), (_vm.step === 2) ? _c('div', {
    staticClass: "form-box"
  }, [_c('el-form', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "类别"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.CATEGORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "CATEGORYNAME", $$v)
      },
      expression: "detail.CATEGORYNAME"
    }
  })], 1), _c('el-form-item', [_c('p', [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_category)))])])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.PRODUCTNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "PRODUCTNAME", $$v)
      },
      expression: "detail.PRODUCTNAME"
    }
  })], 1), _c('el-form-item', [_c('p', [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_product)))])])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "厂商简称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.FACTORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "FACTORYNAME", $$v)
      },
      expression: "detail.FACTORYNAME"
    }
  })], 1), _c('el-form-item', [_c('p', [_vm._v(_vm._s(_vm._f("boolMapper")(_vm.reviewStatus.new_company_alias)))])])], 1)]), (_vm.reviewStatus.check_status === 'additional_info_required') ? _c('div', {
    staticClass: "box"
  }, [_c('el-alert', {
    attrs: {
      "title": "没有找到厂商全称，请补充",
      "type": "warning",
      "center": "center"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "厂商全称"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "size": "small",
      "value": "label",
      "value-key": "label",
      "fetch-suggestions": _vm.querySearchCompanyFullName,
      "placeholder": "查找或输入",
      "trigger-on-focus": false,
      "debounce": 500
    },
    on: {
      "select": _vm.handleSelectCompanyFullName
    },
    model: {
      value: (_vm.companyFullName),
      callback: function($$v) {
        _vm.companyFullName = $$v
      },
      expression: "companyFullName"
    }
  })], 1)], 1)], 1) : _vm._e(), (_vm.reviewStatus.check_status === 'conflict') ? _c('div', {
    staticClass: "box"
  }, [_c('el-alert', {
    attrs: {
      "title": "厂商全称冲突！",
      "type": "error",
      "description": ("产品与厂商简称关联的厂商全称冲突，将忽略该厂商简称。\n 产品关联的厂商全称：" + (_vm.reviewStatus.company_full_name_with_product) + " \n 厂商简称关联的厂商全称：" + (_vm.reviewStatus.company_full_name_with_alias)),
      "show-icon": "show-icon"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "el-form-item bottom-ctrl"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleOneClick
    }
  }, [_vm._v("入库")]), _c('el-button', {
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("上一步")])], 1)], 1) : _vm._e(), (_vm.step === 3) ? _c('div', {
    staticClass: "form-box"
  }, [_vm._m(0), _c('div', {
    staticClass: "log"
  }, _vm._l((_vm.logs), function(note, index) {
    return _c('p', [_vm._v(_vm._s(index + 1) + " - " + _vm._s(note))])
  }), 0), _c('div', {
    staticClass: "el-form-item bottom-ctrl"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("关闭")])], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note"
  }, [_c('i', {
    staticClass: "el-icon-success"
  }), _c('p', [_vm._v("基本信息已入库")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-dc575a28!./~/_vue-loader@9.9.5@vue-loader/lib/template-loader.js?raw&engine=pug!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/posts/Detail.vue
// module id = 480
// module chunks = 11